var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { fetchConsultar, fetchConsultarPaginada, fetchAlterar, fetchArquivos, fetchBlobResource, URL_API } from '../../../api';
import { getTokenFromCookie } from '../../../services/mt_login';
export { STATUS_API } from '../../../api';
var ROTA_CONTRATOS = 'contratos-trabalho';
export var anexarContratoAssinado = function (ContratoID, Arquivo) { return __awaiter(void 0, void 0, void 0, function () {
    var Dados;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                Dados = new FormData();
                Dados.append('arquivo', Arquivo);
                return [4 /*yield*/, fetchArquivos("".concat(ROTA_CONTRATOS, "/").concat(ContratoID, "/contrato-assinado"), Dados)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getContratoAssinadoBlob = function (ContratoID) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchBlobResource("".concat(ROTA_CONTRATOS, "/").concat(ContratoID, "/contrato-assinado/visualizar"))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getContratosTrabalho = function (TextoBusca, Status, Instituicao, DataInicio, DataFim, PaginationModel) { return __awaiter(void 0, void 0, void 0, function () {
    var Query, URL;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                Query = '';
                if (TextoBusca)
                    Query += "query=".concat(encodeURIComponent(TextoBusca), "&");
                if (Status)
                    Query += "status=".concat(encodeURIComponent(Status), "&");
                if (Instituicao)
                    Query += "instituicao=".concat(Instituicao, "&");
                if (DataInicio)
                    Query += "data_inicio=".concat(encodeURIComponent(DataInicio), "&");
                if (DataFim)
                    Query += "data_fim=".concat(encodeURIComponent(DataFim), "&");
                URL = "".concat(ROTA_CONTRATOS, "/?").concat(Query);
                return [4 /*yield*/, fetchConsultarPaginada(URL, PaginationModel)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getContratoTrabalho = function (ContratoID) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchConsultar("".concat(ROTA_CONTRATOS, "/").concat(ContratoID))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getCombosListarContratos = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchConsultar("".concat(ROTA_CONTRATOS, "/combos-listar"))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getCombosEditarContratos = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchConsultar("".concat(ROTA_CONTRATOS, "/combos-editar"))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var alterarContrato = function (Dados, ContratoID) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchAlterar("".concat(ROTA_CONTRATOS, "/").concat(ContratoID, "/encerrar"), Dados)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var gerarExcelContratos = function (TextoBusca, Status, Instituicao, DataInicio, DataFim) { return __awaiter(void 0, void 0, void 0, function () {
    var Query, TOKEN, response, ExcelBlob, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                Query = '';
                if (TextoBusca)
                    Query += "query=".concat(encodeURIComponent(TextoBusca), "&");
                if (Status)
                    Query += "status=".concat(encodeURIComponent(Status), "&");
                if (Instituicao)
                    Query += "instituicao=".concat(Instituicao, "&");
                if (DataInicio)
                    Query += "data_inicio=".concat(encodeURIComponent(DataInicio), "&");
                if (DataFim)
                    Query += "data_fim=".concat(encodeURIComponent(DataFim), "&");
                TOKEN = getTokenFromCookie();
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                return [4 /*yield*/, fetch("".concat(URL_API, "/").concat(ROTA_CONTRATOS, "/excel/?").concat(Query), {
                        method: 'GET',
                        headers: {
                            Authorization: "Bearer ".concat(TOKEN),
                            'Content-Type': 'application/vnd-xls',
                        },
                    })];
            case 2:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error('Failed to fetch Excel');
                }
                return [4 /*yield*/, response.blob()];
            case 3:
                ExcelBlob = _a.sent();
                return [2 /*return*/, window.URL.createObjectURL(ExcelBlob)];
            case 4:
                error_1 = _a.sent();
                console.error('Erro ao gerar o Excel:', error_1);
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); };
export var gerarPDFContratos = function (TextoBusca, Status, Instituicao, DataInicio, DataFim) { return __awaiter(void 0, void 0, void 0, function () {
    var Query, TOKEN, response, pdfBlob, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                Query = '';
                if (TextoBusca)
                    Query += "query=".concat(encodeURIComponent(TextoBusca), "&");
                if (Status)
                    Query += "status=".concat(encodeURIComponent(Status), "&");
                if (Instituicao)
                    Query += "instituicao=".concat(Instituicao, "&");
                if (DataInicio)
                    Query += "data_inicio=".concat(encodeURIComponent(DataInicio), "&");
                if (DataFim)
                    Query += "data_fim=".concat(encodeURIComponent(DataFim), "&");
                TOKEN = getTokenFromCookie();
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                return [4 /*yield*/, fetch("".concat(URL_API, "/").concat(ROTA_CONTRATOS, "/pdf/?").concat(Query), {
                        method: 'GET',
                        headers: {
                            Authorization: "Bearer ".concat(TOKEN),
                            'Content-Type': 'application/pdf',
                        },
                    })];
            case 2:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error('Failed to fetch PDF');
                }
                return [4 /*yield*/, response.blob()];
            case 3:
                pdfBlob = _a.sent();
                return [2 /*return*/, window.URL.createObjectURL(pdfBlob)];
            case 4:
                error_2 = _a.sent();
                console.error('Erro ao gerar o PDF:', error_2);
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); };
